<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> system_update_alt </span>Stock
          actuel
        </div>
      </div>
</div>
      <div id="contratTab" class="tabElementContent active">
        <!-- <div @click="addNewContrat" class="buttonAdd">
            <span> Ajouter un contrat</span>
          </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in globaleStockData"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div
                     @click="addNewContratDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir détails</span>
                    </div>
                  </div>
                </td>
            
                <td >
                  {{ item.product ? item.product.name : "" }}
                </td>
                <td >
                  {{ item.product ? item.product.type : "" }}
                </td>
                <td >
                  {{ item.product ? item.product.unitPrice : "" }}
                </td>
                <td >
                  {{ item.quantity }}
                </td>
                <td >
                  {{ item.quantity && item.product ? item.quantity * item.product.unitPrice : 0  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "adminStock",
  components: {},
  data: () => ({
    tableHeader: [
      "",
      "Désignation produit",
      "Type",
      "Prix unitaire",
      "Quantité disponible",
      "Estimation coût stock",
    ],
    isSelecteds: [],
    isSelectedAll: false,
  }),
  computed: {
    ...mapGetters([
    //   "globaleStockData",
    //   "blData",
    //   "conteneurData",
    //   "contenuerAllData",
    //   "storeData",
    "globaleStockData",
    
    ]),
  },
  async mounted() {
    await this.getGlobaleStoreStock();
  },
  methods: {
    ...mapActions([
    //   "getContrat",
    //   "getSupplier",
    //   "getContratDetails",
    //   "getBl",
    //   "getConteneur",
    //   "getConteneurAll",
    //   "getTransitaire",
    //   "getStore",
      "getGlobaleStoreStock",
      "getStoreStock"
    ]),
    raccourcirTexte(texte) {
      return texte;
      },


    async addNewContratDetails(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.globaleStockData.length; i++) {
          this.globaleStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.globaleStockData);
        const value = {
          _id: item._id,
          modalType: "detailsStock",
          product: item.product ? item.product.name : "",
          productType: item.product ? item.product.type : "",
          quantity: item.quantity,
        };
        await this.getStoreStock({ product:  item.product ? item.product._id : "" });
        this.$emit("editeRowForDash", {
          name: "detailsStock",
          size: 1000,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
  